export const OrganizationRolesForm = [
    {
        "key": "description",
        "type": "input",
        "templateOptions": {
            "attributes": {
                "autofocus": '',
                "autocomplete": "off",
            },
            "type": "text",
            "label": "Name",
            "placeholder": "Name",
            "required": true
        }
    },
]